import { useFeatures, type WorkspaceFeatures } from "@expert/features";
import { useMemo } from "react";

import { useLogger } from "@/sdk/logging";

import { useCallbackStore } from "../callback.store";

const DEFAULT_CALLBACK_LIMIT = 10;

export function useCallbackState() {
    return useCallbackStore((state) => state.callbackState);
}

export function useCallbacksRemaining() {
    const logger = useLogger({ name: "useCallbacksRemaining" });
    const {
        features: { callbackLimit },
    } = useFeatures<WorkspaceFeatures>();
    const callbacksCount = useCallbackStore((state) => state.callbackState?.callbackCount) ?? 0;
    const isInvalidCallbackCount = typeof callbackLimit !== "number" || !Number.isFinite(callbackLimit);
    if (isInvalidCallbackCount) {
        logger.warn({ callbackLimit }, "callbackLimit flag invalid or missing — using DEFAULT_CALLBACK_LIMIT");
    }
    const limit = isInvalidCallbackCount ? DEFAULT_CALLBACK_LIMIT : callbackLimit;

    return useMemo(
        () => ({
            canCallback: callbacksCount < limit,
            callbacksRemaining: Math.max(0, limit - callbacksCount),
        }),
        [callbacksCount, limit],
    );
}

export function getCallbackState() {
    return useCallbackStore.getState().callbackState;
}

export function hasPendingCallback() {
    return useCallbackStore.getState().callbackState?.callbackType === "CallbackNow";
}
